import { useEffect, useState } from 'react';
import { BrandCard, PoweredBy } from '../auth/BrandCard';

const SHOW_MS = 3000;
const FADE_MS = 650;
const SEEN_KEY = 'mm-splash-seen';

function seenThisSession(): boolean {
  try {
    return sessionStorage.getItem(SEEN_KEY) === '1';
  } catch {
    return false;
  }
}

/** The branded intro: about three seconds over the loading map, then it fades. Once per browser session. */
export function IntroSplash({
  logoUrl,
  title,
  subtitle,
}: {
  logoUrl: string | null;
  title: string;
  subtitle: string | null;
}) {
  const [phase, setPhase] = useState<'show' | 'fade' | 'gone'>(() => (seenThisSession() ? 'gone' : 'show'));
  useEffect(() => {
    if (phase === 'gone') return;
    try {
      sessionStorage.setItem(SEEN_KEY, '1');
    } catch {
      /* private mode: show it every time */
    }
    const fade = window.setTimeout(() => setPhase('fade'), SHOW_MS);
    const gone = window.setTimeout(() => setPhase('gone'), SHOW_MS + FADE_MS);
    return () => {
      window.clearTimeout(fade);
      window.clearTimeout(gone);
    };
    // Runs once: the timers own the phase from here.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (phase === 'gone') return null;
  return (
    <div className={phase === 'fade' ? 'mm-splash mm-night hide' : 'mm-splash mm-night'} aria-hidden="true">
      <BrandCard logoUrl={logoUrl} title={title} subtitle={subtitle} />
      <PoweredBy />
    </div>
  );
}
